import { createApp } from "vue";
import App from "./App.vue";
import { Amplify } from "aws-amplify";
import config from "./amplifyconfiguration.json";
import { router } from "@/router";
import apiClient from "./services/api";
import { useNotifications } from "./composables/useNotifications";
import store from "@/store";

Amplify.configure(config);

const app = createApp(App);
app.use(router);
// Provide API client globally
app.config.globalProperties.$api = apiClient;
app.provide("api", apiClient);

app.use(store);

// Provide notifications globally
const notifications = useNotifications();
app.config.globalProperties.$notify = notifications;
app.provide("notifications", notifications);

app.mount("#app");
